var testParams = {
    f: 992,
    platform: 'app',
    uuid: 'adbf8826-4189-4533-b2ce-8cddbe09a22e',
    imei: '',
    xxwxtoken: 'OFuw4cZ0Ble0bZmNdt-FHEYbIOZ-x86QaUjf3qo42XTuyA9Sj-g8G0e93fSDSwJkcuAF09wGFxO6oWyXBfwsP9JJlV_Qe-Na5aA6Ab2z7Rv8TAvPA65fc-OK8IG9pq7KIc4ixOHhbe26mVb12RI580Bh5mOaIl7mppkajaGfqDk1lVrvsz3HGJn1ARwyaxuxWF35GrCr18nVafp9Jbv_m_-FlggNepV_Y2a0vfeiFcL5uU0igR_TgY1JaP0suaRfCObHCHmJsF0SjjtGMb3yu1fSi6hj3Tdk3X0erM_zHc-lwBH1E_QNlKunCwOSGT6N',
    xxwxtokenp: '2$ZSeIBwSmyM6-ksuKuYhQPfaDWJvzavGPKD1QMqYX2bstmC_zNr7DW4R6SPgnV_R1W5mwcxK7Zw8SYmizM7PWiOiEU5flVqjswVxzdr5k-8fPDqZR-mnXRs-ErTXcV7itD5Fd6rjuSeNS0BXkP1R9qY-q-Cdyp2Rb2KXUv30pIJeh0yobTCz5f2WFXOGIZFwRFT2kmUi65hCX-xV1-wW0GKEQPqGMlV_H067Q6b412JdT_bWWso5RySh6E7fkVMl_jAlxC6bqVz7q2UNKsQZRJ-WLecvjI1Sl-sWl0xUm3R9EGXFxV3X7Fkp4Cvg7WCRWhqx4yU1GV1CiVl8A8FcJpg==',
    openudid: 'guestbd4c2992b2a44040aab007f38850b13f',
    os: 'android',
    version: '12.8.0',
    clientId: '405ba05cfdf3cd7993f9cec9a53143fe',
    productorid: '1',
    accessmode: 'undefined',
    uid: '',
    ppu: '',
    utoken: '7af295b02dc8a8d31001a9c60d32e4b5',
};
export { testParams };
